import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSafeShield2Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.2978 2.19546C11.7505 2.02567 12.2495 2.02567 12.7022 2.19546L19.7022 4.82046C20.4829 5.11318 21 5.85943 21 6.69312V12.0558C21 15.4648 19.074 18.5812 16.0249 20.1057L12.6708 21.7827C12.2485 21.9939 11.7515 21.9939 11.3292 21.7827L7.97508 20.1057C4.92602 18.5812 3 15.4648 3 12.0558V6.69312C3 5.85943 3.51715 5.11318 4.29775 4.82046L11.2978 2.19546ZM12 4.06812L5 6.69312V12.0558C5 14.7072 6.49802 17.1311 8.8695 18.3168L12 19.8821V4.06812Z",
		fill: "currentColor"
	})
});
export default SvgSafeShield2Fill;
